import {createContext} from "react";

/**
 * Context that keeps track of the current state of the mobile icon menu.
 */
export const MobileIconMenuContext: React.Context<boolean> =
    createContext<boolean>(false);
MobileIconMenuContext.displayName = "MobileIconMenuContext";

/**
 * Context providing an API for updating state for the mobile icon menu.
 */
export const MobileIconMenuAPIContext: React.Context<(arg1: boolean) => void> =
    createContext<(arg1: boolean) => void>(() => {
        throw new Error("Must be used within MobileIconMenuContextProvider.");
    });
